// extracted by mini-css-extract-plugin
export default {"clockNumber":"Clock_clockNumber__sfy5A","clockDivision":"Clock_clockDivision__4OK6b"};